var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hgroup',[(_vm.subTitle)?_c('h2',{staticClass:"secondary--text text-uppercase subheading font-weight-bold"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_c('h1',{staticClass:"display-2 font-weight-black mb-1"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }